"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Event_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = void 0;
const package_1 = require("../package");
const schema_1 = require("../ontologies/schema");
const Thing_1 = require("./Thing");
const Person_1 = require("./Person");
const Place_1 = require("./Place");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const XSDDate_1 = require("lincd-xsd/lib/shapes/XSDDate");
const ShapeSet_1 = require("lincd/lib/collections/ShapeSet");
const ImageObject_1 = require("./ImageObject");
let Event = Event_1 = class Event extends Thing_1.Thing {
    get startDate() {
        return this.hasProperty(schema_1.schema.startDate)
            ? XSDDate_1.XSDDate.toNativeDate(this.getOne(schema_1.schema.startDate))
            : null;
    }
    set startDate(nativeDate) {
        this.overwrite(schema_1.schema.startDate, XSDDate_1.XSDDate.fromNativeDate(nativeDate).node);
    }
    get endDate() {
        return this.hasProperty(schema_1.schema.endDate)
            ? XSDDate_1.XSDDate.toNativeDate(this.getOne(schema_1.schema.endDate))
            : null;
    }
    set endDate(nativeDate) {
        this.overwrite(schema_1.schema.endDate, XSDDate_1.XSDDate.fromNativeDate(nativeDate).node);
    }
    get attendees() {
        return Person_1.Person.getSetOf(this.getAll(schema_1.schema.attendee));
    }
    get location() {
        return this.getOneAs(schema_1.schema.location, Place_1.Place);
    }
    set location(val) {
        this.overwrite(schema_1.schema.location, val ? val.node : null);
    }
    get image() {
        return this.getOneAs(schema_1.schema.image, ImageObject_1.ImageObject);
    }
    set image(val) {
        this.overwrite(schema_1.schema.image, val.node);
    }
    get superEvent() {
        return this.getOneAs(schema_1.schema.superEvent, Event_1);
    }
    set superEvent(val) {
        this.overwrite(schema_1.schema.superEvent, val.node);
    }
};
exports.Event = Event;
Event.targetClass = schema_1.schema.Event;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.startDate,
    }),
    __metadata("design:type", Date),
    __metadata("design:paramtypes", [Date])
], Event.prototype, "startDate", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.endDate,
    }),
    __metadata("design:type", Date),
    __metadata("design:paramtypes", [Date])
], Event.prototype, "endDate", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.attendee,
        shape: Person_1.Person,
    }),
    __metadata("design:type", ShapeSet_1.ShapeSet),
    __metadata("design:paramtypes", [])
], Event.prototype, "attendees", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.location,
        shape: Place_1.Place,
    }),
    __metadata("design:type", Place_1.Place),
    __metadata("design:paramtypes", [Place_1.Place])
], Event.prototype, "location", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.image,
        shape: ImageObject_1.ImageObject,
    }),
    __metadata("design:type", ImageObject_1.ImageObject),
    __metadata("design:paramtypes", [ImageObject_1.ImageObject])
], Event.prototype, "image", null);
exports.Event = Event = Event_1 = __decorate([
    package_1.linkedShape
], Event);
//# sourceMappingURL=Event.js.map